document.addEventListener("DOMContentLoaded", function() {

	var $ = jQuery.noConflict();

    /**
	 * Center Initial tab on Partners Home Component
	 */
	if ($('.section__partners').length) {
		setTimeout(function() {
			$('.section__partners .nav-link').removeClass('active');
			$('.section__partners .tab-pane').removeClass('active show').addClass('d-none');
			
			$('.section__partners .nav-link').eq(0).addClass('active');
			$('.section__partners #tab-1').addClass('active show').removeClass('d-none');
		}, 100);

		$('.section__partners .nav-link').on('click', function(event) {
			event.preventDefault(); 
	
			$('.section__partners .nav-link').removeClass('active');
			$('.section__partners .tab-pane').removeClass('active show').addClass('d-none');
	
			$(this).addClass('active');
	
			const targetTab = $(this).attr('href');
			$(targetTab).addClass('active show').removeClass('d-none');
		});
	}

    $('.bpi-tabs--prev').click(function() {
		$(".bpi-tabs--nav").animate({scrollLeft: "-=100px"});
	});
	
	$('.bpi-tabs--next').click(function() {
		$(".bpi-tabs--nav").animate({scrollLeft: "+=100px"});
	});
});